const LoadScripts = {
    methods: {
        async loadScripts() {
            await Promise.all([
                    this.$loadScript("assets/vendor/dpx-image/dpx-fe.js"),
                    this.$loadScript("assets/vendor/canvas-to-tiff/canvastotiff.js"),
                    this.$loadScript("assets/vendor/utif/utif.js")
                ]
            )
        },
    },
};

export default LoadScripts;
